import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Text,
} from '@ltvco/refresh-lib/theme';
import { Close } from '@mui/icons-material';

import { useCallerIdSmokeTest } from './CallerIdSmokeTestContext';

/**
 * Coming-soon modal for Smart Caller ID smoke test (RFRSH-4427).
 * Notify action persists opt-in and closes the modal; CTAs then stay hidden.
 */
export function CallerIdModal(): JSX.Element | null {
  const {
    isExperienceActive,
    isMobile,
    modalOpen,
    closeModal,
    onNotifyClick,
    onNotInterestedClick,
  } = useCallerIdSmokeTest();

  if (!isMobile || !isExperienceActive) {
    return null;
  }

  return (
    <Dialog
      fullScreen
      open={modalOpen}
      onClose={closeModal}
      aria-labelledby="caller-id-smoke-modal-title"
    >
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          justifyContent: 'center',
          pt: 6,
          px: 3,
          pb: 3,
        }}
      >
        <IconButton
          aria-label="Close"
          onClick={closeModal}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <Close />
        </IconButton>

        <Text
          id="caller-id-smoke-modal-title"
          variant="h5"
          component="h2"
          gutterBottom
        >
          Smart Caller ID is coming soon
        </Text>
        <Text variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
          Get real-time caller info, fraud scores, and spam alerts—before you
          answer.
        </Text>
        <Stack spacing={1.5} width="100%">
          <Button variant="contained" color="primary" onClick={onNotifyClick}>
            Notify me when available
          </Button>
          <Button variant="text" color="inherit" onClick={onNotInterestedClick}>
            Not interested
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
